import React, { useCallback, useState, useEffect } from "react";
import Toast from "../LoadingError/Toast";
import { Link } from "react-router-dom";
import Message from "../LoadingError/Error";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import MainPanel from "../main-panel/MainPanel";
import { FAQ_UPDATE_RESET } from "../../Redux/Constants/FaqConstants";
import { faqEditAction, faqUpdateAction } from "../../Redux/Actions/FaqAction";
import { Box, Button, Checkbox, Heading, Spinner, Text } from "@chakra-ui/react";

const ToastObjects = {
  pauseOnFocusLoss: false,
  draggable: false,
  pauseOnHover: false,
  autoClose: 2000,
};

const EditFaqMain = (props) => {
  const { faqId } = props;
  let DefaultLanguageList = [
    { id: 1, langKey: "AZ" },
    { id: 2, langKey: "GB" },
    { id: 3, langKey: "RU" },
  ];

  const [status, setStatus] = useState(false);
  const [language, setLanguage] = useState([]);

  const dispatch = useDispatch();

  const onHandleLangChange = useCallback(
    (dataInfo) => {
      let languageList = {
        faqId: parseInt(faqId),
        id: parseInt(dataInfo.id),
        name: dataInfo.name,
        description: dataInfo.description,
        seoTitle: dataInfo.seoTitle,
        seoDescription: dataInfo.seoDescription,
        languageKey: dataInfo.lang,
      };
      setLanguage((ln) => [
        ...ln.filter(
          (l) => l.languageKey !== dataInfo.lang && l.languageKey !== "" && typeof (l.languageKey) != 'undefined'
        ),
        languageList,
      ]);
    },
    [faqId]
  );

  const faqEdit = useSelector((state) => state.faqEdit);
  const { loading, error, faq } = faqEdit;

  const faqUpdate = useSelector((state) => state.faqUpdate);
  const { loading: loadingUpdate, error: errorUpdate, success: successUpdate } = faqUpdate;

  useEffect(() => {
    if (successUpdate) {
      dispatch({ type: FAQ_UPDATE_RESET });
      toast.success("FAQ Updated", ToastObjects);
    } else {
      if (!faq || faq.id !== parseInt(faqId)) {
        dispatch(faqEditAction(faqId));
      } else {
        setLanguage(faq.faqrecords);
        setStatus(faq.status);
      }
    }
  }, [faq, dispatch, faqId, successUpdate]);

  const submitHandler = (e) => {
    e.preventDefault();

    dispatch(
      faqUpdateAction({
        id: faqId,
        status,
        faqRecords: language.filter((l) => l.languageKey !== "" && typeof l.languageKey !== "undefined"),
      })
    );
  };

  return (
    <>
      <Toast />
      <Box maxW="1200px" mx="auto" p={4}>
        <form onSubmit={submitHandler}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={4}
          >
            <Button
              as={Link}
              to="/faqs"
              colorScheme="red"
              variant="solid"
              _hover={{
                backgroundColor: "red.600",
                color: "white",
              }}
            >
              Go to FAQs
            </Button>
            <Heading as="h2" size="lg" color="teal.600">
              Update FAQ
            </Heading>
            <Button type="submit" colorScheme="teal">
              Publish Now
            </Button>
          </Box>

          <Box bg="white" p={6} shadow="md" borderRadius="lg">
            {errorUpdate && (
              <Message variant="alert-danger">{errorUpdate}</Message>
            )}
            {loadingUpdate && <Spinner color="blue.500" size="lg" />}
            {loading ? (
              <Spinner color="blue.500" size="lg" />
            ) : error ? (
              <Message variant="alert-danger">{error}</Message>
            ) : (
              <>
                <MainPanel
                  mainLang={DefaultLanguageList}
                  languageInfo={language}
                  changeLang={onHandleLangChange}
                />
                <Box mt={6}>
                  <Checkbox
                    colorScheme="teal"
                    isChecked={status}
                    onChange={(e) => setStatus(e.target.checked)}
                  >
                    <Text fontSize="lg">Mark as Active</Text>
                  </Checkbox>
                </Box>
              </>
            )}
          </Box>
        </form>
      </Box>
    </>
  );
};

export default EditFaqMain;
